import { c as _c } from "react/compiler-runtime";
import { BaseHit, Hit } from 'instantsearch.js';
import { useHits } from 'react-instantsearch';
export function removeExcerptPTags(excerpt: string): string {
  return excerpt.replace(/<\/?p>/g, '');
}
export interface StrategyItem extends Hit<BaseHit> {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  link: string;
}
export function transformAlgoliaStrategies(hits: Hit[]): StrategyItem[] {
  return hits.filter(hit => {
    // Filter out child posts (only show top-level posts with no parent)
    // Posts with parent_id = 0 or undefined are top-level posts
    return !hit.parent_id || hit.parent_id === 0;
  }).map(hit => ({
    id: hit.objectID,
    title: hit.post_title,
    description: removeExcerptPTags(hit.post_excerpt),
    imageUrl: hit.images.thumbnail?.url,
    link: hit.permalink
  })) as unknown as StrategyItem[];
}
export function useAlgoliaStrategies() {
  const $ = _c(5);
  const {
    hits
  } = useHits();
  let t0;
  if ($[0] !== hits) {
    t0 = transformAlgoliaStrategies(hits);
    $[0] = hits;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const transformedHits = t0;
  const label = hits[0]?.post_type_label as string ?? "";
  let t1;
  if ($[2] !== label || $[3] !== transformedHits) {
    t1 = {
      label,
      hits: transformedHits
    };
    $[2] = label;
    $[3] = transformedHits;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}